import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";

export const EbookPosterContainer = () => {
  return (
    <section
      className="featured-section catalogue-section position-relative"
      style={{ backgroundImage: 'url("https://cdn.wes.com.au/wesreact/newui/img/home-page/catalogue-download.png")' }}
    >
      <div className="container-fluid container-lg">
        <div className="row align-items-center">
          <div className="col-12 col-sm-6 col-md-6">
            <div className="catalogue-download">
              <h2 className="fw-bold">View Latest Catalogue Online</h2>
              <p>
                Over <b>1200</b> Pages of AV, Data, Power / Security Solutions and more.
              </p>
              <div className="categlog-button mt-4">
                <div className="button-effect">
                  <Link to={PAGES.ONLINE_CATALOGUE} className="btn btn-products theme-primary" data-guest-allow>
                    View Book
                  </Link>
                </div>
                <div className="newProducts-btn">
                  <Link to={PAGES.NEWPRODUCTS_CT}>New Products</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6"></div>
        </div>
      </div>
    </section>
  );
};
